export default __webpack_public_path__ + "static/media/evan low.8cf3dc57.jpg";